import gql from "graphql-tag";

export const GET_SIGNED_URL = gql`
query getSignedS3Url ($s3Url: String!) {
    getSignedS3Url(s3Url: $s3Url) 
}
`;

